var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWarningRedBackgroundIcon = function SvgWarningRedBackgroundIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#FB355D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0163 39.3751H38.9788C41.2247 39.3751 42.6247 36.9397 41.5017 35.0001L30.5205 16.0272C29.3976 14.0876 26.5976 14.0876 25.4747 16.0272L14.4934 35.0001C13.3705 36.9397 14.7705 39.3751 17.0163 39.3751ZM27.9976 29.1668C27.1955 29.1668 26.5392 28.5105 26.5392 27.7084V24.7918C26.5392 23.9897 27.1955 23.3334 27.9976 23.3334C28.7997 23.3334 29.4559 23.9897 29.4559 24.7918V27.7084C29.4559 28.5105 28.7997 29.1668 27.9976 29.1668ZM29.4559 35.0001H26.5392V32.0834H29.4559V35.0001Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWarningRedBackgroundIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "warning-red-background-icon.c0e6529855fe8abf260e6335a84b62e7.svg";